import InternalLink from "@/components/ui/internal-link";
import Section from "@/components/ui/section";
import React from "react";
import { services } from "@/components/data/services";
import Image from "next/image";
export default function OurWork() {
  return (
    <Section className="bg-[#fafafa]">
      <div className="flex flex-col items-center w-full">
        <h2 className="lg:text-5xl text-4xl font-semibold text-center mb-4 text-blue heading [&>span]:text-lightBlue">
          <span>Our</span> Work
        </h2>

        <div className="grid lg:grid-cols-2 grid-cols-1 auto-rows-auto gap-[30px] md:mt-8 mt-4 lg:max-w-[1180px] mx-auto">
          {services?.map((service, key) => (
            <Block key={"service" + key} data={service} />
          ))}
        </div>
      </div>
    </Section>
  );
}
const Block = ({ data }) => {
  const { name, description, image, link } = data;
  return (
    <div className="w-full shrink-0 rounded-[16px] bg-white md:px-[30px] px-4 md:py-8 py-6 shadow-serviceCard flex lg:odd:flex-col-reverse md:flex-col flex-col-reverse md:gap-5 gap-3">
      <div className="flex flex-col w-full gap-3">
        <p className="md:text-2xl text-lg font-bold text-blue">{name}</p>
        <p>{description}</p>
        <InternalLink
          href={link}
          className="mt-2 min-w-[130px]"
          variant="darkBlue"
        >
          Learn more
        </InternalLink>
      </div>
      <div className="w-full rounded-[16px] md:h-[338px] h-[184px] relative overflow-hidden lg:mt-auto mt-0">
        <Image
          src={image ?? "/images/placeholder.svg"}
          alt={name}
          fill
          className="object-cover object-center"
          sizes="(max-width: 479px) 700px,(max-width: 768px) 700px, (max-width: 1200px) 700px,(max-width: 1920px) 700px, 500px"
        />
      </div>
    </div>
  );
};
